import { defer, EMPTY, Observable } from 'rxjs';
import UploadedPhoto from '@/model/UploadedPhoto';
import { filter, mergeMap, share } from 'rxjs/operators';
import convertErrors from './convertErrors';
import noErrors from './noErrors';
import errorsOnly from './errorsOnly';

interface ContainsPhoto { photo: UploadedPhoto; }

export default function createServiceObservables<T extends ContainsPhoto, R>(
    serviceName: string,
    source$: Observable<T>,
    serviceCallback: (input: T) => Promise<R>,
    concurrency = 1,
) {
    const withErrors$ = source$.pipe(
        mergeMap(input => defer(() => input.photo.active
            ? serviceCallback(input).then(result => ({ ...result, photo: input.photo }))
            : EMPTY,
        ).pipe(
            convertErrors(input.photo, serviceName),
            filter(() => input.photo.active),
        ), concurrency),
        share(),
    );
    return {
        withErrors$,
        withoutErrors$: withErrors$.pipe(noErrors()),
        errorsOnly$: withErrors$.pipe(errorsOnly()),
    };
}
